import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import SvgHilbiCheck from '../../../assets/hb-check.svg'
import Card from '../card'
import { format, parseISO } from 'date-fns'
import { IUserEvaluationChecks } from 'src/types/feed'

const StyledFeedRunningRecord = styled.div`
  p {
    color: #333d6c;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;

    > span,
    &.title {
      font-weight: 700;
      font-size: 14px;
      line-height: 16px;
    }
  }

  div.title {
  }

  div.description {
  }

  div.checkbox-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    margin-top: 32px;
    margin-bottom: 32px;

    gap: 16px 96px;

    div.wrapper {
      width: 100%;
      max-width: 150px;
      margin-right: 48px;

      > img {
        margin-right: 16px;
      }
    }
  }
`

interface IFeedRunningRecordProps {
  description: string
  programStep: number
  totalStepCount: number | undefined
  risk: number
  createdAt: string | Date
  nextCheckAt: string
  data?: IUserEvaluationChecks
}

const FeedRunningRecord = ({
  createdAt,
  description,
  risk,
  programStep,
  totalStepCount,
  nextCheckAt,
  data,
}: IFeedRunningRecordProps) => {
  const { t } = useTranslation()

  return (
    <Card date={createdAt}>
      <StyledFeedRunningRecord>
        <p className='title'>{t('addRunningCycleRecord.feed.medicalRecord')}</p>

        <p className='description'>{description}</p>
        <div className='checkbox-grid'>
          {data?.diabetes && (
            <div className='wrapper'>
              <img src={SvgHilbiCheck} alt='check' />
              <span>{t('addRunningCycleRecord.checkboxes.diabetes')}</span>
            </div>
          )}

          {data?.obesity && (
            <div className='wrapper'>
              <img src={SvgHilbiCheck} alt='check' />
              <span>{t('addRunningCycleRecord.checkboxes.obesity')}</span>
            </div>
          )}

          {data?.smoker && (
            <div className='wrapper'>
              <img src={SvgHilbiCheck} alt='check' />
              <span>{t('addRunningCycleRecord.checkboxes.smoker')}</span>
            </div>
          )}
        </div>
        <p>
          {t('addRunningCycleRecord.feed.step')}:{' '}
          <span>
            {programStep} / {totalStepCount}
          </span>
        </p>
        <p>
          {t('addRunningCycleRecord.feed.examination')}:{' '}
          <span>{format(parseISO(nextCheckAt), 'd.M.y')}</span>
        </p>
      </StyledFeedRunningRecord>
    </Card>
  )
}

export default FeedRunningRecord
